/**
 * Loading skeleton for Folder View
 */

import { Skeleton } from '@loader/ui';

import type { ViewMode } from './types';

interface FolderViewSkeletonProps {
  viewMode: ViewMode;
}

export function FolderViewSkeleton({ viewMode }: FolderViewSkeletonProps) {
  const count = viewMode === 'grid' ? 6 : 4;

  if (viewMode === 'grid') {
    return (
      <div className="flex flex-wrap gap-1">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="flex w-24 flex-col items-center rounded-md p-2">
            <Skeleton className="size-8 rounded-md" />
            <Skeleton className="mt-2 h-4 w-3/4" />
            <Skeleton className="mt-1 h-3 w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex items-center gap-4 rounded-lg border p-3">
          <Skeleton className="size-10 rounded-lg" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-1/4" />
            <Skeleton className="h-3 w-1/2" />
          </div>
          <Skeleton className="h-4 w-20" />
        </div>
      ))}
    </div>
  );
}
